import { API_BASE_URL } from '@synergy/config';
import { PaginatedResponse } from '@synergy/api';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { HeaderBannerApi } from '../api/header-banner-api';
import { HeaderBannerDto } from '../models/dto/header-banner-dto';

const api = new HeaderBannerApi(API_BASE_URL);

export const headerBannersReceived = createAction<PaginatedResponse<HeaderBannerDto>>('header-banner/loaded');

export const fetchActiveHeaderBanners = () => async (dispatch: AppDispatch) => {
    const response = await api.getActiveHeaderBanners();
    if (response.success) {
        dispatch(headerBannersReceived(response.result));
    }
    // We don't show an error if failed - just don't display the header banner
};
